import { css } from 'emotion';
import chevronDown from 'images/icons/chevron-down-16.svg';
import snakeCase from 'lodash/snakeCase';
import React from 'react';
import Select, { MenuPlacement } from 'react-select';
import { ActionMeta, ValueType } from 'react-select/src/types';
import { customStyles } from './MultiSelectStyles';

export interface SelectOption<TValue = string> {
  label: string;
  description?: string;
  value: TValue;
}

interface Props<T = string> {
  id: string;
  isMulti: boolean;
  value?: SelectOption<T> | SelectOption<T>[] | null | undefined;
  className?: string;
  options: SelectOption<T>[];
  menuPlacement: MenuPlacement;
  onChange: (
    selectOptions: ValueType<SelectOption<T>, boolean>,
    actionsMeta: ActionMeta<SelectOption<T>>
  ) => void;
  defaultValue?: ValueType<SelectOption<T>, boolean>;
  components?: any;
  label?: string;
  selected?: string;
}

class BaseSelect<T = string> extends React.Component<Props<T>> {
  static defaultProps = {
    isMulti: false,
    menuPlacement: 'auto',
  };

  render(): React.ReactNode {
    const { id, menuPlacement, label, selected } = this.props;

    return (
      <Select
        styles={customStyles}
        aria-label={label}
        components={{
          Option: ({ children, getStyles, innerRef, ...props }) => {
            // NOTE: the use of emotion directly below is required by react-select to do custom styling.
            //       This is an exception to normal styling policies. Emotion should not be used elsewhere.
            const cn = css(getStyles('option', props));
            const val = snakeCase(props.data.value);
            const selectedClass =
              props.data.value === selected ? 'selected' : '';

            return (
              <div
                ref={innerRef}
                {...props.innerProps}
                className={`${cn} ${id}-option ${id}-option-${val} select-option ${selectedClass}`}
              >
                {children}
              </div>
            );
          },
          IndicatorsContainer: () => {
            return (
              <div id={`${id}-down-chevron`} className="px2 dropdown-icon">
                <img src={chevronDown} alt="Add Item" />
              </div>
            );
          },
        }}
        {...this.props}
        inputId={`${id}-select`}
        menuPlacement={menuPlacement}
      />
    );
  }
}

export default BaseSelect;
